'use client';

import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface CTASectionProps {
  title: string;
  description: string;
  primaryButtonText: string;
  primaryButtonLink: string;
  secondaryButtonText: string;
  secondaryButtonLink: string;
}

const CTASection: React.FC<CTASectionProps> = ({
  title,
  description,
  primaryButtonText,
  primaryButtonLink,
  secondaryButtonText,
  secondaryButtonLink,
}) => {
  return (
    <section className="py-20 lg:py-28 bg-surface">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="font-serif text-3xl lg:text-4xl font-bold text-primary mb-6">
          {title}
        </h2>
        <p className="text-lg text-text-secondary mb-10 leading-relaxed">
          {description}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            href={primaryButtonLink}
            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-gradient-to-r from-accent to-gold-dark text-primary font-semibold rounded-lg shadow-subtle hover:shadow-elevation-sm hover:scale-102 transition-all duration-300"
          >
            {primaryButtonText}
            <Icon name="ArrowRightIcon" size={20} />
          </Link>
          <Link
            href={secondaryButtonLink}
            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-primary text-white font-semibold rounded-lg border-2 border-primary hover:bg-navy-dark hover:border-navy-dark transition-all duration-300"
          >
            {secondaryButtonText}
            <Icon name="PhoneIcon" size={20} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;